import { Box, Button, Divider, Paper } from '@mui/material'
import { ORDER_TYPES } from 'context/OrderContext'
import React from 'react'
import CustomButton from "components/Fileds/CustomButton"
import CustomTypography from 'components/Fileds/CustomTypography'
import OrderItemsContainer from 'components/OrderItems/OrderItems'
import { useSelector } from 'react-redux'
import { formatCurrency } from 'utils/function'

const NewOrderItemPanelContainer = ({
    handleAddItem,
    handleRemoveItem,
    handleCreateOrder,
    userData,
    isLoading,
    theme,
    orderType,
    orderItems,
    tax,
    platformFee,
    // discount,
    orderTotal,
    cartTotal,
    prevOrderItemTotal,
    additionalTotal,
    cartItemtax,
    cartItemplatformFee,
    cartItemAdditionalTotal
}) => {
    const vendorData = useSelector((state) => state?.posData?.vendor);

    return (
        <Box className="cart-order-panel-container">
            <Paper className='cart-order-details-cotainer'
                elevation={0}
                sx={{marginTop:'0px !important'}}
            >
                {/* Header with title */}
                <Box className='order-type-title' sx={{py: `16px !important`}}>
                    <CustomTypography
                        label={"New Order Items"}
                        sx={{
                            fontWeight: 600, fontSize: '18px', mb: 0,
                            color: theme.palette.typographyLabel.main
                        }}
                    />
                </Box>

                <Divider />

                {/* Order items */}
                <Box className='order-items-container'>
                    <OrderItemsContainer
                        orderItems={orderItems}
                        handleRemoveItem={handleRemoveItem}
                        handleAddItem={handleAddItem}
                        userData={userData}
                        showLabel={true}
                    />
                </Box>


                {/* Order summary - only show if there are items */}
                {orderItems.length > 0 && (
                    <Box className='summary-order-item'>
                        <Box className='d-flex justify-content-between' sx={{ mb: 1 }}>
                            <CustomTypography
                                variant={'body1'}
                                label={"New Items Total"}
                                sx={{ fontSize: '16px', fontWeight: 400, mb: 0 }}
                            />
                            <CustomTypography
                                variant={'body1'}
                                label={formatCurrency(cartTotal.toFixed(2) || 0, userData.vendor.currency)}
                                sx={{ fontSize: '16px', fontWeight: 400, mb: 0 }}
                            />
                        </Box>
                        <Box className='d-flex justify-content-between' sx={{ mb: 1 }}>
                            <CustomTypography
                                variant={"body2"}
                                label={`Tax (${vendorData?.service_tax}%)`}
                                sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                            />
                            <CustomTypography
                                variant="body2"
                                label={formatCurrency(cartItemtax.toFixed(2) || 0, userData.vendor.currency)}
                                sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                            />
                        </Box>
                        {cartItemplatformFee > 0 && (
                            <Box className='d-flex justify-content-between' sx={{ mb: 1 }}>
                                <CustomTypography
                                    variant={"body2"}
                                    label={`Platform Fee (${vendorData?.platform_fee}%)`}
                                    sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                />
                                <CustomTypography
                                    variant="body2"
                                    label={formatCurrency(cartItemplatformFee.toFixed(2) || 0, userData.vendor.currency)}
                                    sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                />
                            </Box>
                        )}

                        {/* Discount for table booking */}
                        {/* {orderType === ORDER_TYPES.TABLE_BOOKING && (
                            <Box className='d-flex justify-content-between'
                                sx={{ mb: 1 }}
                            >
                                <CustomTypography
                                    variant={"body2"}
                                    label={"Discount (10%)"}
                                    sx={{ color: theme.palette.highlight.main, fontSize: "14px", fontWeight: 400, mb: 0 }}
                                />
                                <CustomTypography
                                    variant={"body2"}
                                    label={`-${discount.toFixed(2)}`}
                                    sx={{ color: theme.palette.highlight.main, fontSize: "14px", fontWeight: 400, mb: 0 }}
                                />
                            </Box>
                        )} */}
                        
                        <Box className='d-flex justify-content-between' sx={{ mb: 1 }}>
                            <CustomTypography
                                variant={'body1'}
                                label={"Additional Total"}
                                sx={{ fontSize: '16px', fontWeight: 600, mb: 0 }}
                            />
                            <CustomTypography
                                variant={'body1'}
                                label={formatCurrency(parseFloat(cartItemAdditionalTotal).toFixed(2) || 0, userData.vendor.currency)}
                                sx={{ fontSize: '16px', fontWeight: 600, mb: 0 }}
                            />
                        </Box>
                        
                        <Box className='d-flex justify-content-between'>
                            <CustomTypography
                                variant={"body1"}
                                label={"Main Order Total"}
                                sx={{
                                    fontSize: '16px', fontWeight: 500,
                                    color: "#1297DE", mb: 0
                                }}
                            />
                            <CustomTypography
                                variant={"body1"}
                                label={formatCurrency(orderTotal.toFixed(2) || 0, userData.vendor.currency)}
                                sx={{
                                    fontSize: '16px', fontWeight: 500,
                                    color: "#1297DE", mb: 0
                                }}
                            />
                        </Box>
                    </Box>
                )}

                {/* Action buttons - only show if there are items */}
                <Box sx={{ p: 2, pt: "20px" }}>
                    <CustomButton
                        variant="contained"
                        fullWidth
                        sx={{
                            py: 3,
                            borderRadius: '10px',
                            fontSize: "18px",
                            fontWeight: 600,
                            textTransform: 'none'
                        }}
                        onClick={handleCreateOrder}
                        disabled={isLoading || orderItems?.length === 0} // Disable button while loading
                    >
                        {/* {isLoading ? "Creating Order..." : "Create Order Item"} */}
                        {isLoading
                            ? (prevOrderItemTotal ? "Updating Order..." : "Creating Order...")
                            : (prevOrderItemTotal ? "Update Order Item" : "Create Order Item")}
                    </CustomButton>
                </Box>
            </Paper>
        </Box>
    )
}

export default NewOrderItemPanelContainer
